import {IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../api/get_is_user_authenticated";

export const selectIsUserAuthenticated = (state: IRootState): boolean => {
    const cachedQuery = getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.select(undefined)(state);
    /**
     * The last known status has to answer while a revalidation is in flight (`isSuccess` is false then).
     * Guards built on this selector (e.g. `getUserProfile`) would otherwise treat a logged in user as
     * anonymous whenever any consumer refetches `users/info/` - RTK Query keeps `data` during the refetch
     */
    return !!cachedQuery.data;
};
import {IRootState} from "../../store/store";
import {getIsUserAuthenticatedApi} from "../api/get_is_user_authenticated";

export const selectIsUserAuthenticated = (state: IRootState): boolean => {
    const cachedQuery = getIsUserAuthenticatedApi.endpoints.getIsUserAuthenticated.select(undefined)(state);
    /**
     * The last known status has to answer while a revalidation is in flight (`isSuccess` is false then).
     * Guards built on this selector (e.g. `getUserProfile`) would otherwise treat a logged in user as
     * anonymous whenever any consumer refetches `users/info/` - RTK Query keeps `data` during the refetch
     */
    return !!cachedQuery.data;
};
